import { CheckoutPlan } from "@generated"
import { ActivePlanType } from "@lib/get-active-plan-type"
import { getGraphqlClient } from "@lib/graphql-client"
import { useCurrency } from "@lib/hooks/use-currency"
import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useState } from "react"

const { sdk } = getGraphqlClient()

export function useSubscribeToBusinessPlan(
  activePlanType: ActivePlanType,
  handleSuccessWithoutStripeCheckout: () => void,
) {
  const { currency } = useCurrency()
  const [showBasicToBusinessModal, setShowBasicToBusinessModal] =
    useState(false)
  const queryClient = useQueryClient()
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async () =>
      await sdk.CreateCheckoutSession({
        input: {
          currency,
          cancelUrl: `${window.location.origin}/app?subscription=error`,
          successUrl: `${
            window.location.origin
          }/app?subscription=success&subscribed_plan=Business&purchase_time=${new Date().toISOString()}`,
          plan: CheckoutPlan.BusinessPlan_2022V1,
          downgradeReason: null,
        },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["me"] })
      queryClient.invalidateQueries({ queryKey: ["account"] })
      queryClient.invalidateQueries({ queryKey: ["plans"] })
      queryClient.invalidateQueries({ queryKey: ["credits"] })
    },
  })

  async function handleClickSubscribe() {
    // If the user is on the basic plan, show the modal
    // If the modal is already visible, we can continue (the user clicked the confirmation button in the modal)
    if (activePlanType === "BASIC" && !showBasicToBusinessModal) {
      setShowBasicToBusinessModal(true)

      return
    } else {
      setShowBasicToBusinessModal(false)
    }

    const stripeCheckoutIsNeeded = activePlanType !== "BASIC"
    const result = await mutateAsync()

    if (result && result.createCheckoutSession) {
      if (stripeCheckoutIsNeeded) {
        location.href = result.createCheckoutSession.url
      } else {
        handleSuccessWithoutStripeCheckout()
      }
    }
  }

  return {
    showBasicToBusinessModal,
    setShowBasicToBusinessModal,
    handleClickSubscribe,
    isPending,
  }
}
